/*
* FormsReducer
*/

import { fromJS } from 'immutable';
import {
  PRINT_OFFER,
  SEARCH_CUSTOMER,
  CUSTOMER_RECEIVED,
  RESET_RECEIVED,
} from './constants';

// The initial state of forms
export const initialState = fromJS({
  loading: false,
  offer: null,
  name: null,
  category: null,
  monthly_rate: null,
  accessories: [],
  colors: [],
  search: false,
  customerCode: '',
  customer: {},
});

function formsReducer(state = initialState, action) {
  switch (action.type) {
    case PRINT_OFFER:
      return state
        .set('offer', action.offer)
        .set('monthly_rate', action.price)
        .set('name', action.name)
        .set('category', action.contractualCategory)
        .set('accessories', action.accessories)
        .set('colors', action.colors)
        .set('loading', true);
    case SEARCH_CUSTOMER:
      return state.set('customerCode', action.code).set('search', true);
    case CUSTOMER_RECEIVED:
      return state.set('customer', action.customer).set('search', false);
    case RESET_RECEIVED:
      return state.set('customer', {}).set('search', false);
    default:
      return state;
  }
}

export default formsReducer;
